<div class="custella-login">
    <!-- brand (same placement as screen #1) -->
    <a class="fe-brand">
      <img src="../../../assets/svg/FieldEx_Logo_Full_W.svg" alt="FieldEx" />
    </a>

  <div class="container">
    <div class="row">
      <div class="mx-auto">
        <div class="card setup-card border-0 shadow-none rounded-3 login-mobile">
          <div class="card-body p-0">
            <div class="setup-panel setup-app">
              <h2 class="setup-title">Open in the FieldEx App</h2>

              <div class="setup-hero">
                <!-- replace with your mobile illustration -->
                <img class="setup-illustration-phone" src="../../../assets/svg/userOnMobile.svg" alt="Use the FieldEx mobile app" />
              </div>

              <div class="setup-text">
                <div class="setup-lead">
                  For the best performance and security, please continue in the FieldEx mobile app.
                </div>
                <p class="setup-copy">
                  Download the mobile app and log in with your username
                  and password to get started.
                </p>
              </div>

              <div class="store-row" role="group" aria-label="App download badges">
                <!-- Use official store badge images from your assets/CDN -->
                <a class="store-badge"aria-label="Download on the App Store" rel="noopener" (click)="openAppStore()">
                  <img src="../../../assets/svg/appleStore.svg" alt="Download on the App Store">
                </a>
                <a class="store-badge" aria-label="Get it on Google Play" rel="noopener" (click)="openPlayStore()">
                  <img src="../../../assets/svg/googlePlay.svg" alt="Get it on Google Play">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
